import { UseFormReturn } from 'react-hook-form';
import { ExportOrderForm } from '../ExportOrderModal.types';
import useGroupByClassification from './useGroupByClassification';
import { usePdfBaseOptions } from './usePdfBaseOptions';

export const usePdfContentOptions = ({
  formValues,
}: { formValues: UseFormReturn<ExportOrderForm> }) => {
  const options = usePdfBaseOptions();
  useGroupByClassification(formValues);
  return options;
};
